import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  snackbarData,
  userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHAreaIns } from "services/services-mia/programa-salud/estructuras/RNHAreaIns";

export default function InsertModal({ updateList, servicio, closeModal, filtro }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const [inRequest, setInRequest] = useState(false);
  const zonas = filtro;
  const formikRef = useRef();

  const handleCreateArea = async (values) => {
    const response = await RNHAreaIns(
      credentials,
      { zonaCod: values.zonaCod, wkt: values.wkt, nombre: values.nombre, cod: values.cod },
    );
    if (response.ok) {
      setSnackBarInfo({
        message: "Área creada correctamente",
        severity: "success",
        open: true,
      });
      formikRef.current.resetForm();
      updateList();
      closeModal();
    } else {
      setSnackBarInfo({
        message: response.error?.mensaje || "No se pudo crear el área",
        severity: "error",
        open: true,
      });
    }
  }
  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        nombre: "",
        zonaCod: "",
        cod: "",
        wkt: ""
      }}
      validationSchema={
        yup.object({
          nombre: yup.string("Debe ingresar un nombre").max(LARGO.nombre, mensajeLargo(LARGO.nombre)).required("Debe ingresar un nombre"),
          zonaCod: yup.string("Debe seleccionar una zona").required("Debe ingresar una zona"),
          cod: yup.string("Debe ingresar un Código").max(LARGO.cod, mensajeLargo(LARGO.cod)).required("Debe ingresar un Código"),
        })
      }
      onSubmit={(values) => {
        handleCreateArea(values);
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={2}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
            }}
          >
            <Grid item xs={12}>
              <FormikTextInput
                fullWidth={true}
                name="nombre"
                labelText="Nombre"
                  inputProps={{ maxLength: LARGO.nombre }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormikTextInput
                fullWidth={true}
                name="cod"
                labelText="Código"
                  inputProps={{ maxLength: LARGO.cod }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormikSelectInput
                fullWidth={true}
                name="zonaCod"
                labelText="Zona"
                onChange={(e) => {
                  formikRef.current.setFieldValue("zonaCod", e.target.value);
                }}
              >
                <option value="" selected disabled >Seleccione</option>
                {zonas.map(({ rnhZonaCod, rnhZonaNombre }) => (
                  <option key={rnhZonaCod} value={rnhZonaCod}>
                    {rnhZonaNombre}
                  </option>
                ))}
              </FormikSelectInput>
            </Grid>
          </Grid>
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Crear" }}
            onCloseModal={closeModal}
          />
          {(inRequest) && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
